export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("es-CL", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("es-CL", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function formatApplicantName(applicant: { firstName?: string | null; lastName?: string | null } | null | undefined): string {
  if (!applicant) return "—";
  const cap = (s?: string | null) =>
    s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : "";
  return [cap(applicant.firstName), cap(applicant.lastName)].filter(Boolean).join(" ") || "—";
}

const COUNTRY_NAMES: Record<string, string> = {
  CL: "Chile",
  AR: "Argentina",
  PE: "Perú",
  CO: "Colombia",
  MX: "México",
  UY: "Uruguay",
  EC: "Ecuador",
  BR: "Brasil",
  ES: "España",
  US: "Estados Unidos",
};

export function formatCountry(code: string | null | undefined): string {
  if (!code) return "—";
  return COUNTRY_NAMES[code.toUpperCase()] ?? code;
}

const COMMON_COUNTRY_OPTIONS: Array<{ value: string; label: string }> = [
  { value: "CL", label: "Chile" },
  { value: "AR", label: "Argentina" },
  { value: "PE", label: "Perú" },
  { value: "CO", label: "Colombia" },
  { value: "MX", label: "México" },
  { value: "UY", label: "Uruguay" },
  { value: "EC", label: "Ecuador" },
  { value: "BR", label: "Brasil" },
];

export function countryOptions() {
  return COMMON_COUNTRY_OPTIONS;
}
